import { render, staticRenderFns } from "./ConstructionTypeForm.vue?vue&type=template&id=b9c814ee&"
import script from "./ConstructionTypeForm.vue?vue&type=script&lang=ts&"
export * from "./ConstructionTypeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports